import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

const AppTooltip = ({ children, text, placement = "top", delay = { show: 100, hide: 200 } }) => {
  return (
    <OverlayTrigger
      trigger={["click", "focus", "hover"]}
      placement={placement}
      delay={delay}
      overlay={<Tooltip>{text}</Tooltip>}
    >
      {children}
    </OverlayTrigger>
  );
};

export default AppTooltip;